import React from 'react';
import Banner from '../components/Banner';
import Footer from '../components/Footer';
import PreguntasFr from '../components/PreguntasFrecuentes';

const PreguntasFrecuentes: React.FC = () => {
  return (
    <div className="page-container">
      <Banner />
         <main className="login-main">
        <PreguntasFr />
      </main>
      <Footer />
    </div>
  );
};

export default PreguntasFrecuentes;
